<div class="max-w-3xl mx-auto px-4 py-16">
  <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
    Conditions Générales d'Utilisation
  </h1>
  <p class="text-sm text-gray-400 mb-8">Dernière mise à jour : mars 2026</p>
  <div class="prose prose-gray max-w-none text-gray-600 dark:text-gray-400 space-y-6">
    <section>
      <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">1. Objet</h2>
      <p>
        Les présentes CGU définissent les conditions d'accès et d'utilisation du
        service Predivent, accessible à l'adresse analyticai.com.
      </p>
    </section>
    <section>
      <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">
        2. Accès au service
      </h2>
      <p>
        Le service est accessible après création d'un compte. L'utilisateur
        s'engage à fournir des informations exactes et à maintenir la
        confidentialité de ses identifiants.
      </p>
    </section>
    <section>
      <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">
        3. Données personnelles
      </h2>
      <p>
        Les données collectées sont utilisées exclusivement pour fournir le
        service. Consultez notre
        <a routerLink="/confidentialite" class="text-purple-600 hover:underline"
          >politique de confidentialité</a
        >
        pour plus de détails.
      </p>
    </section>
    <section>
      <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">
        4. Responsabilité
      </h2>
      <p>
        Predivent fournit un service d'aide à la décision. Les recommandations
        ne constituent pas une garantie de résultat. L'utilisateur reste seul
        responsable de ses décisions commerciales.
      </p>
    </section>
    <section>
      <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">5. Contact</h2>
      <p>
        Pour toute question :
        <a routerLink="/contact" class="text-purple-600 hover:underline"
          >nous contacter</a
        >.
      </p>
    </section>
  </div>
</div>
